var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('el-dialog', {
    attrs: {
      "title": _vm.dataForm.id ? 'Edit Currency' : 'Add Currency',
      "visible": _vm.dialogVisible,
      "close-on-click-modal": false,
      "width": "500px"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogVisible = $event;
      }
    }
  }, [_c('el-form', {
    ref: "formRef",
    attrs: {
      "model": _vm.dataForm,
      "rules": _vm.dataRule,
      "label-position": "right",
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Currency Code",
      "prop": "currency"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "SGD"
    },
    model: {
      value: _vm.dataForm.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "currency", $$v);
      },
      expression: "dataForm.currency"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Currency Symbol",
      "prop": "symbol"
    }
  }, [_c('el-input', {
    attrs: {
      "clearable": "",
      "placeholder": "S$"
    },
    model: {
      value: _vm.dataForm.symbol,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "symbol", $$v);
      },
      expression: "dataForm.symbol"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "Basis Amount",
      "prop": "exchangeRateBasis"
    }
  }, [_c('el-select', {
    staticClass: "wdb100",
    attrs: {
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.exchangeRateBasis,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "exchangeRateBasis", $$v);
      },
      expression: "dataForm.exchangeRateBasis"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "1",
      "value": 1
    }
  }), _c('el-option', {
    attrs: {
      "label": "100",
      "value": 100
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function click($event) {
        _vm.dialogVisible = false;
      }
    }
  }, [_vm._v("Cancel")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.dataFormSubmit
    }
  }, [_vm._v("OK")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }